// API Configuration File
// Base URL and configuration for all API endpoints

export const BASE_URL = 'https://ctmapi.zerlak.com/api/v1';

export const API_ENDPOINTS = {
  // Authentication Endpoints
  AUTH: {
    LOGIN: '/auth/login'
  },
  
  // Dashboard Endpoints
  DASHBOARD: {
    GET_DATA: '/challans/getDashboardData'
  },
  
  // Customer Endpoints
  CUSTOMERS: {
    SEARCH: '/customers/search',
    CREATE: '/customers/create',
    GET_BY_ID: (id) => `/customers/${id}`,
    UPDATE: (id) => `/customers/${id}`,
    DELETE: (id) => `/customers/${id}`,
    DELETE_BY_ID: (id) => `/customers/deleteById/${id}`,
    VIEW: '/customers/search?page=0&size=9'
  },
  
  // Challan Endpoints
  CHALLANS: {
    GET_ALL: '/challans',
    CREATE: '/challans/create',
    GET_BY_ID: (id) => `/challans/${id}`,
    UPDATE: (id) => `/challans/${id}`,
    DELETE: (id) => `/challans/${id}`,
    DELETE_BY_ID: (id) => `/challans/deleteChallanById/${id}`,
    DOWNLOAD: (id) => `/challans/download/${id}`,
    FILTER: '/challans/filter',
    SEARCH: '/challans/searchChallans'
  },
  
  // Goods/Cylinder Endpoints
  GOODS: {
    GET_ALL: '/goods',
    CREATE: '/goods/create',
    UPDATE: (id) => `/goods/${id}`,
    DELETE: (id) => `/goods/${id}`,
    SEARCH: '/goods/search'
  },
  
  // Cylinder Master Endpoints
  CYLINDERS: {
    GET_ALL: '/cylinders',
    CREATE: '/cylinders/create',
    UPDATE: (id) => `/cylinders/${id}`,
    DELETE: (id) => `/cylinders/${id}`,
    SEARCH: '/cylinders/search'
  },
  
  // Passbook Endpoints
  PASSBOOK: {
    GET_ALL: '/passbook',
    CREATE: '/passbook/create',
    UPDATE: (id) => `/passbook/${id}`,
    DELETE: (id) => `/passbook/${id}`,
    FILTER: '/passbook/filter'
  },
  
  // Profile Endpoints
  PROFILE: {
    GET: '/profile',
    UPDATE: '/profile/update',
    CHANGE_PASSWORD: '/profile/change-password'
  },
  
  // Settings Endpoints
  SETTINGS: {
    GET: '/settings/getSettings',
    UPDATE: '/settings/update'
  },
  
  // User Endpoints
  USERS: {
    GET_ALL: '/settings/users/getAllUsers'
  }
};

export default { BASE_URL, API_ENDPOINTS };
